/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { buildFileControllerCreate } from '../fn/build-file/build-file-controller-create';
import { BuildFileControllerCreate$Params } from '../fn/build-file/build-file-controller-create';
import { buildFileControllerDelete } from '../fn/build-file/build-file-controller-delete';
import { BuildFileControllerDelete$Params } from '../fn/build-file/build-file-controller-delete';
import { buildFileControllerFindAll } from '../fn/build-file/build-file-controller-find-all';
import { BuildFileControllerFindAll$Params } from '../fn/build-file/build-file-controller-find-all';
import { buildFileControllerFindById } from '../fn/build-file/build-file-controller-find-by-id';
import { BuildFileControllerFindById$Params } from '../fn/build-file/build-file-controller-find-by-id';
import { buildFileControllerSearchCursor } from '../fn/build-file/build-file-controller-search-cursor';
import { BuildFileControllerSearchCursor$Params } from '../fn/build-file/build-file-controller-search-cursor';
import { buildFileControllerSearchOffset } from '../fn/build-file/build-file-controller-search-offset';
import { BuildFileControllerSearchOffset$Params } from '../fn/build-file/build-file-controller-search-offset';
import { buildFileControllerUpdate } from '../fn/build-file/build-file-controller-update';
import { BuildFileControllerUpdate$Params } from '../fn/build-file/build-file-controller-update';
import { BuildFileDto } from '../models/build-file-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class BuildFileService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `buildFileControllerFindAll()` */
  static readonly BuildFileControllerFindAllPath = '/api/build-file';

  /**
   * 빌드 파일 전체 조회.
   *
   * 빌드 파일 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerFindAll$Response(params?: BuildFileControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuildFileDto>>> {
    return buildFileControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 전체 조회.
   *
   * 빌드 파일 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerFindAll(params?: BuildFileControllerFindAll$Params, context?: HttpContext): Observable<Array<BuildFileDto>> {
    return this.buildFileControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<BuildFileDto>>): Array<BuildFileDto> => r.body)
    );
  }

  /** Path part for operation `buildFileControllerCreate()` */
  static readonly BuildFileControllerCreatePath = '/api/build-file';

  /**
   * 빌드 파일 생성.
   *
   * 빌드 파일을 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerCreate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  buildFileControllerCreate$Response(params: BuildFileControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
    return buildFileControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 생성.
   *
   * 빌드 파일을 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerCreate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  buildFileControllerCreate(params: BuildFileControllerCreate$Params, context?: HttpContext): Observable<BuildFileDto> {
    return this.buildFileControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuildFileDto>): BuildFileDto => r.body)
    );
  }

  /** Path part for operation `buildFileControllerSearchOffset()` */
  static readonly BuildFileControllerSearchOffsetPath = '/api/build-file/search/offset';

  /**
   * 빌드 파일 오프셋 기반 조회.
   *
   * 빌드 파일을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerSearchOffset$Response(params: BuildFileControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return buildFileControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 오프셋 기반 조회.
   *
   * 빌드 파일을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerSearchOffset(params: BuildFileControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.buildFileControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `buildFileControllerSearchCursor()` */
  static readonly BuildFileControllerSearchCursorPath = '/api/build-file/search/cursor';

  /**
   * 빌드 파일 커서 기반 조회.
   *
   * 빌드 파일을 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerSearchCursor$Response(params: BuildFileControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return buildFileControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 커서 기반 조회.
   *
   * 빌드 파일을 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerSearchCursor(params: BuildFileControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.buildFileControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `buildFileControllerFindById()` */
  static readonly BuildFileControllerFindByIdPath = '/api/build-file/{id}';

  /**
   * 빌드 파일 ID 기반 조회.
   *
   * 빌드 파일을 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerFindById$Response(params: BuildFileControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
    return buildFileControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 ID 기반 조회.
   *
   * 빌드 파일을 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerFindById(params: BuildFileControllerFindById$Params, context?: HttpContext): Observable<BuildFileDto> {
    return this.buildFileControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuildFileDto>): BuildFileDto => r.body)
    );
  }

  /** Path part for operation `buildFileControllerDelete()` */
  static readonly BuildFileControllerDeletePath = '/api/build-file/{id}';

  /**
   * 빌드 파일 삭제.
   *
   * 빌드 파일을 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerDelete$Response(params: BuildFileControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
    return buildFileControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 삭제.
   *
   * 빌드 파일을 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  buildFileControllerDelete(params: BuildFileControllerDelete$Params, context?: HttpContext): Observable<BuildFileDto> {
    return this.buildFileControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuildFileDto>): BuildFileDto => r.body)
    );
  }

  /** Path part for operation `buildFileControllerUpdate()` */
  static readonly BuildFileControllerUpdatePath = '/api/build-file/{id}';

  /**
   * 빌드 파일 수정.
   *
   * 빌드 파일을 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `buildFileControllerUpdate()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  buildFileControllerUpdate$Response(params: BuildFileControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BuildFileDto>> {
    return buildFileControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 빌드 파일 수정.
   *
   * 빌드 파일을 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `buildFileControllerUpdate$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  buildFileControllerUpdate(params: BuildFileControllerUpdate$Params, context?: HttpContext): Observable<BuildFileDto> {
    return this.buildFileControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<BuildFileDto>): BuildFileDto => r.body)
    );
  }

}
